"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1226],{

/***/ 79824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ck": function() { return /* binding */ REWARD_RATE; },
/* harmony export */   "ND": function() { return /* binding */ FUTURE_ROUND_COUNT; },
/* harmony export */   "eQ": function() { return /* binding */ LEADERBOARD_MIN_ROUNDS_PLAYED; },
/* harmony export */   "fq": function() { return /* binding */ ROUND_BUFFER; },
/* harmony export */   "v9": function() { return /* binding */ PAST_ROUND_COUNT; },
/* harmony export */   "yg": function() { return /* binding */ ROUNDS_PER_PAGE; }
/* harmony export */ });
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16816);

var REWARD_RATE = 0.97;
// Estimated number of seconds it takes to submit a transaction (3 blocks) in seconds
var ROUND_BUFFER = config__WEBPACK_IMPORTED_MODULE_0__/* .BSC_BLOCK_TIME */ .hJ * 3;
var PAST_ROUND_COUNT = 5;
var FUTURE_ROUND_COUNT = 2;
var ROUNDS_PER_PAGE = 200;
var LEADERBOARD_MIN_ROUNDS_PLAYED = 10;


/***/ }),

/***/ 1226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ub": function() { return /* binding */ LEADERBOARD_RESULTS_PER_PAGE; },
  "x4": function() { return /* binding */ Result; },
  "oO": function() { return /* binding */ fetchUserRounds; },
  "t$": function() { return /* binding */ fetchUsersRoundsLength; },
  "Fr": function() { return /* binding */ getBetHistory; },
  "jG": function() { return /* binding */ getClaimStatuses; },
  "fq": function() { return /* binding */ getFilteredBets; },
  "HJ": function() { return /* binding */ getHasRoundFailed; },
  "Tq": function() { return /* binding */ getLedgerData; },
  "n": function() { return /* binding */ getPredictionData; },
  "s9": function() { return /* binding */ getPredictionUser; },
  "D": function() { return /* binding */ getPredictionUsers; },
  "yz": function() { return /* binding */ getRoundResult; },
  "$8": function() { return /* binding */ getRoundsData; },
  "yn": function() { return /* binding */ getTotalWon; },
  "CM": function() { return /* binding */ makeFutureRoundResponse; },
  "a8": function() { return /* binding */ makeLedgerData; },
  "D5": function() { return /* binding */ makeRoundData; },
  "zN": function() { return /* binding */ parseBigNumberObj; },
  "WB": function() { return /* binding */ serializePredictionsRoundsResponse; },
  "ld": function() { return /* binding */ transformBetResponse; },
  "r3": function() { return /* binding */ transformUserResponse; }
});

// UNUSED EXPORTS: serializePredictionsLedgerResponse

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(6647);
// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(80173);
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(10528);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(50071);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(60242);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 26 modules
var contractHelpers = __webpack_require__(36561);
// EXTERNAL MODULE: ./src/config/abi/predictions.json
var predictions = __webpack_require__(45883);
// EXTERNAL MODULE: ../../node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(90711);
;// CONCATENATED MODULE: ./src/state/predictions/bnbQueries.ts
/**
 * Base fields are the all the top-level fields available in the api. Used in multiple queries
 */ var roundBaseFields = "\n  id\n  epoch\n  position\n  failed\n  startAt\n  startBlock\n  startHash\n  lockAt\n  lockBlock\n  lockHash\n  lockPrice\n  lockRoundId\n  closeAt\n  closeBlock\n  closeHash\n  closePrice\n  closeRoundId\n  totalBets\n  totalAmount\n  bullBets\n  bullAmount\n  bearBets\n  bearAmount\n";
var betBaseFields = "\n id\n hash  \n amount\n position\n claimed\n claimedAt\n claimedHash\n claimedBlock\n claimedBNB\n claimedNetBNB\n createdAt\n updatedAt\n";
var userBaseFields = "\n  id\n  createdAt\n  updatedAt\n  block\n  totalBets\n  totalBetsBull\n  totalBetsBear\n  totalBNB\n  totalBNBBull\n  totalBNBBear\n  totalBetsClaimed\n  totalBNBClaimed\n  winRate\n  averageBNB\n  netBNB\n";

;// CONCATENATED MODULE: ./src/state/predictions/cakeQueries.ts
/**
 * Base fields are the all the top-level fields available in the api. Used in multiple queries
 */ var cakeQueries_roundBaseFields = "\n  id\n  epoch\n  position\n  failed\n  startAt\n  startBlock\n  startHash\n  lockAt\n  lockBlock\n  lockHash\n  lockPrice\n  lockRoundId\n  closeAt\n  closeBlock\n  closeHash\n  closePrice\n  closeRoundId\n  totalBets\n  totalAmount\n  bullBets\n  bullAmount\n  bearBets\n  bearAmount\n";
var cakeQueries_betBaseFields = "\n id\n hash  \n amount\n position\n claimed\n claimedAt\n claimedHash\n claimedBlock\n claimedCAKE\n claimedNetCAKE\n createdAt\n updatedAt\n";
var cakeQueries_userBaseFields = "\n  id\n  createdAt\n  updatedAt\n  block\n  totalBets\n  totalBetsBull\n  totalBetsBear\n  totalCAKE\n  totalCAKEBull\n  totalCAKEBear\n  totalBetsClaimed\n  totalCAKEClaimed\n  winRate\n  averageCAKE\n  netCAKE\n";

;// CONCATENATED MODULE: ./src/state/predictions/queries.ts


var getRoundBaseFields = function(tokenSymbol) {
    return tokenSymbol === "CAKE" ? cakeQueries_roundBaseFields : roundBaseFields;
};
var getBetBaseFields = function(tokenSymbol) {
    return tokenSymbol === "CAKE" ? cakeQueries_betBaseFields : betBaseFields;
};
var getUserBaseFields = function(tokenSymbol) {
    return tokenSymbol === "CAKE" ? cakeQueries_userBaseFields : userBaseFields;
};

// EXTERNAL MODULE: ./src/state/predictions/config.ts
var config = __webpack_require__(79824);
;// CONCATENATED MODULE: ./src/utils/numberOrNull.ts
var numberOrNull = function(value) {
    if (value === null) {
        return null;
    }
    var valueNum = Number(value);
    return Number.isNaN(valueNum) ? null : valueNum;
};
/* harmony default export */ var utils_numberOrNull = (numberOrNull);

;// CONCATENATED MODULE: ./src/state/predictions/cakeTransformers.ts


var getRoundPosition = function(positionResponse) {
    if (positionResponse === "Bull") {
        return types/* BetPosition.BULL */.Tu.BULL;
    }
    if (positionResponse === "Bear") {
        return types/* BetPosition.BEAR */.Tu.BEAR;
    }
    if (positionResponse === "House") {
        return types/* BetPosition.HOUSE */.Tu.HOUSE;
    }
    return null;
};
var transformBetResponseCAKE = function(betResponse) {
    var bet = {
        id: betResponse.id,
        hash: betResponse.hash,
        block: utils_numberOrNull(betResponse.block),
        amount: betResponse.amount ? parseFloat(betResponse.amount) : 0,
        position: betResponse.position === "Bull" ? types/* BetPosition.BULL */.Tu.BULL : types/* BetPosition.BEAR */.Tu.BEAR,
        claimed: betResponse.claimed,
        claimedAt: utils_numberOrNull(betResponse.claimedAt),
        claimedBlock: utils_numberOrNull(betResponse.claimedBlock),
        claimedHash: betResponse.claimedHash,
        claimedBNB: betResponse.claimedCAKE ? parseFloat(betResponse.claimedCAKE) : 0,
        claimedNetBNB: betResponse.claimedNetCAKE ? parseFloat(betResponse.claimedNetCAKE) : 0,
        createdAt: utils_numberOrNull(betResponse.createdAt),
        updatedAt: utils_numberOrNull(betResponse.updatedAt)
    };
    if (betResponse.user) {
        bet.user = transformUserResponseCAKE(betResponse.user);
    }
    if (betResponse.round) {
        bet.round = transformRoundResponseCAKE(betResponse.round);
    }
    return bet;
};
var transformUserResponseCAKE = function(userResponse) {
    var _ref = userResponse || {}, id = _ref.id, createdAt = _ref.createdAt, updatedAt = _ref.updatedAt, block = _ref.block, totalBets = _ref.totalBets, totalBetsBull = _ref.totalBetsBull, totalBetsBear = _ref.totalBetsBear, totalCAKE = _ref.totalCAKE, totalCAKEBull = _ref.totalCAKEBull, totalCAKEBear = _ref.totalCAKEBear, totalBetsClaimed = _ref.totalBetsClaimed, totalCAKEClaimed = _ref.totalCAKEClaimed, winRate = _ref.winRate, averageCAKE = _ref.averageCAKE, netCAKE = _ref.netCAKE;
    return {
        id: id,
        createdAt: utils_numberOrNull(createdAt),
        updatedAt: utils_numberOrNull(updatedAt),
        block: utils_numberOrNull(block),
        totalBets: utils_numberOrNull(totalBets),
        totalBetsBull: utils_numberOrNull(totalBetsBull),
        totalBetsBear: utils_numberOrNull(totalBetsBear),
        totalBNB: totalCAKE ? parseFloat(totalCAKE) : 0,
        totalBNBBull: totalCAKEBull ? parseFloat(totalCAKEBull) : 0,
        totalBNBBear: totalCAKEBear ? parseFloat(totalCAKEBear) : 0,
        totalBetsClaimed: utils_numberOrNull(totalBetsClaimed),
        totalBNBClaimed: totalCAKEClaimed ? parseFloat(totalCAKEClaimed) : 0,
        winRate: winRate ? parseFloat(winRate) : 0,
        averageBNB: averageCAKE ? parseFloat(averageCAKE) : 0,
        netBNB: netCAKE ? parseFloat(netCAKE) : 0
    };
};
var transformRoundResponseCAKE = function(roundResponse) {
    var id = roundResponse.id, epoch = roundResponse.epoch, failed = roundResponse.failed, position = roundResponse.position, startAt = roundResponse.startAt, startBlock = roundResponse.startBlock, startHash = roundResponse.startHash, lockAt = roundResponse.lockAt, lockBlock = roundResponse.lockBlock, lockHash = roundResponse.lockHash, lockPrice = roundResponse.lockPrice, lockRoundId = roundResponse.lockRoundId, closeAt = roundResponse.closeAt, closeBlock = roundResponse.closeBlock, closeHash = roundResponse.closeHash, closePrice = roundResponse.closePrice, closeRoundId = roundResponse.closeRoundId, totalBets = roundResponse.totalBets, totalAmount = roundResponse.totalAmount, bullBets = roundResponse.bullBets, bullAmount = roundResponse.bullAmount, bearBets = roundResponse.bearBets, bearAmount = roundResponse.bearAmount, _roundResponse_bets = roundResponse.bets, bets = _roundResponse_bets === void 0 ? [] : _roundResponse_bets;
    return {
        id: id,
        failed: failed,
        startHash: startHash,
        lockHash: lockHash,
        lockRoundId: lockRoundId,
        closeRoundId: closeRoundId,
        closeHash: closeHash,
        position: getRoundPosition(position),
        epoch: utils_numberOrNull(epoch),
        startAt: utils_numberOrNull(startAt),
        startBlock: utils_numberOrNull(startBlock),
        lockAt: utils_numberOrNull(lockAt),
        lockBlock: utils_numberOrNull(lockBlock),
        lockPrice: lockPrice ? parseFloat(lockPrice) : 0,
        closeAt: utils_numberOrNull(closeAt),
        closeBlock: utils_numberOrNull(closeBlock),
        closePrice: closePrice ? parseFloat(closePrice) : 0,
        totalBets: utils_numberOrNull(totalBets),
        totalAmount: totalAmount ? parseFloat(totalAmount) : 0,
        bullBets: utils_numberOrNull(bullBets),
        bullAmount: bullAmount ? parseFloat(bullAmount) : 0,
        bearBets: utils_numberOrNull(bearBets),
        bearAmount: bearAmount ? parseFloat(bearAmount) : 0,
        bets: bets.map(transformBetResponseCAKE)
    };
};

;// CONCATENATED MODULE: ./src/state/predictions/bnbTransformers.ts


var bnbTransformers_getRoundPosition = function(positionResponse) {
    if (positionResponse === "Bull") {
        return types/* BetPosition.BULL */.Tu.BULL;
    }
    if (positionResponse === "Bear") {
        return types/* BetPosition.BEAR */.Tu.BEAR;
    }
    if (positionResponse === "House") {
        return types/* BetPosition.HOUSE */.Tu.HOUSE;
    }
    return null;
};
var transformBetResponseBNB = function(betResponse) {
    var bet = {
        id: betResponse.id,
        hash: betResponse.hash,
        block: utils_numberOrNull(betResponse.block),
        amount: betResponse.amount ? parseFloat(betResponse.amount) : 0,
        position: betResponse.position === "Bull" ? types/* BetPosition.BULL */.Tu.BULL : types/* BetPosition.BEAR */.Tu.BEAR,
        claimed: betResponse.claimed,
        claimedAt: utils_numberOrNull(betResponse.claimedAt),
        claimedBlock: utils_numberOrNull(betResponse.claimedBlock),
        claimedHash: betResponse.claimedHash,
        claimedBNB: betResponse.claimedBNB ? parseFloat(betResponse.claimedBNB) : 0,
        claimedNetBNB: betResponse.claimedNetBNB ? parseFloat(betResponse.claimedNetBNB) : 0,
        createdAt: utils_numberOrNull(betResponse.createdAt),
        updatedAt: utils_numberOrNull(betResponse.updatedAt)
    };
    if (betResponse.user) {
        bet.user = transformUserResponseBNB(betResponse.user);
    }
    if (betResponse.round) {
        bet.round = transformRoundResponseBNB(betResponse.round);
    }
    return bet;
};
var transformUserResponseBNB = function(userResponse) {
    var _ref = userResponse || {}, id = _ref.id, createdAt = _ref.createdAt, updatedAt = _ref.updatedAt, block = _ref.block, totalBets = _ref.totalBets, totalBetsBull = _ref.totalBetsBull, totalBetsBear = _ref.totalBetsBear, totalBNB = _ref.totalBNB, totalBNBBull = _ref.totalBNBBull, totalBNBBear = _ref.totalBNBBear, totalBetsClaimed = _ref.totalBetsClaimed, totalBNBClaimed = _ref.totalBNBClaimed, winRate = _ref.winRate, averageBNB = _ref.averageBNB, netBNB = _ref.netBNB;
    return {
        id: id,
        createdAt: utils_numberOrNull(createdAt),
        updatedAt: utils_numberOrNull(updatedAt),
        block: utils_numberOrNull(block),
        totalBets: utils_numberOrNull(totalBets),
        totalBetsBull: utils_numberOrNull(totalBetsBull),
        totalBetsBear: utils_numberOrNull(totalBetsBear),
        totalBNB: totalBNB ? parseFloat(totalBNB) : 0,
        totalBNBBull: totalBNBBull ? parseFloat(totalBNBBull) : 0,
        totalBNBBear: totalBNBBear ? parseFloat(totalBNBBear) : 0,
        totalBetsClaimed: utils_numberOrNull(totalBetsClaimed),
        totalBNBClaimed: totalBNBClaimed ? parseFloat(totalBNBClaimed) : 0,
        winRate: winRate ? parseFloat(winRate) : 0,
        averageBNB: averageBNB ? parseFloat(averageBNB) : 0,
        netBNB: netBNB ? parseFloat(netBNB) : 0
    };
};
var transformRoundResponseBNB = function(roundResponse) {
    var id = roundResponse.id, epoch = roundResponse.epoch, failed = roundResponse.failed, position = roundResponse.position, startAt = roundResponse.startAt, startBlock = roundResponse.startBlock, startHash = roundResponse.startHash, lockAt = roundResponse.lockAt, lockBlock = roundResponse.lockBlock, lockHash = roundResponse.lockHash, lockPrice = roundResponse.lockPrice, lockRoundId = roundResponse.lockRoundId, closeAt = roundResponse.closeAt, closeBlock = roundResponse.closeBlock, closeHash = roundResponse.closeHash, closePrice = roundResponse.closePrice, closeRoundId = roundResponse.closeRoundId, totalBets = roundResponse.totalBets, totalAmount = roundResponse.totalAmount, bullBets = roundResponse.bullBets, bullAmount = roundResponse.bullAmount, bearBets = roundResponse.bearBets, bearAmount = roundResponse.bearAmount, _roundResponse_bets = roundResponse.bets, bets = _roundResponse_bets === void 0 ? [] : _roundResponse_bets;
    return {
        id: id,
        failed: failed,
        startHash: startHash,
        lockHash: lockHash,
        lockRoundId: lockRoundId,
        closeRoundId: closeRoundId,
        closeHash: closeHash,
        position: bnbTransformers_getRoundPosition(position),
        epoch: utils_numberOrNull(epoch),
        startAt: utils_numberOrNull(startAt),
        startBlock: utils_numberOrNull(startBlock),
        lockAt: utils_numberOrNull(lockAt),
        lockBlock: utils_numberOrNull(lockBlock),
        lockPrice: lockPrice ? parseFloat(lockPrice) : 0,
        closeAt: utils_numberOrNull(closeAt),
        closeBlock: utils_numberOrNull(closeBlock),
        closePrice: closePrice ? parseFloat(closePrice) : 0,
        totalBets: utils_numberOrNull(totalBets),
        totalAmount: totalAmount ? parseFloat(totalAmount) : 0,
        bullBets: utils_numberOrNull(bullBets),
        bullAmount: bullAmount ? parseFloat(bullAmount) : 0,
        bearBets: utils_numberOrNull(bearBets),
        bearAmount: bearAmount ? parseFloat(bearAmount) : 0,
        bets: bets.map(transformBetResponseBNB)
    };
};

;// CONCATENATED MODULE: ./src/state/predictions/helpers.ts







function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getTotalWonData {\n          market(id: 1) {\n            totalBNB\n            totalBNBTreasury\n          }\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query getTotalWonData {\n          market(id: 1) {\n            totalCAKE\n            totalCAKETreasury\n          }\n        }\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query getBetHistory($first: Int!, $skip: Int!, $where: Bet_filter) {\n        bets(first: $first, skip: $skip, where: $where, orderBy: createdAt, orderDirection: desc) {\n          ",
        "\n          round {\n            ",
        "\n          }\n          user {\n            ",
        "\n          }\n        }\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query getUsers($first: Int!, $skip: Int!, $where: User_filter, $orderBy: User_orderBy, $orderDir: OrderDirection) {\n        users(first: $first, skip: $skip, where: $where, orderBy: $orderBy, orderDirection: $orderDir) {\n          ",
        "\n        }\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query getUser($id: ID!) {\n        user(id: $id) {\n          ",
        "\n        }\n      }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}












var Result;
(function(Result) {
    Result["WIN"] = "win";
    Result["LOSE"] = "lose";
    Result["CANCELED"] = "canceled";
    Result["HOUSE"] = "house";
    Result["LIVE"] = "live";
})(Result || (Result = {}));
var transformBetResponse = function(tokenSymbol) {
    return tokenSymbol === "CAKE" ? transformBetResponseCAKE : transformBetResponseBNB;
};
var transformUserResponse = function(tokenSymbol) {
    return tokenSymbol === "CAKE" ? transformUserResponseCAKE : transformUserResponseBNB;
};
var getRoundResult = function(bet, currentEpoch) {
    var round = bet.round;
    if (round.failed) {
        return Result.CANCELED;
    }
    if (round.epoch >= currentEpoch - 1) {
        return Result.LIVE;
    }
    if (bet.round.position === types/* BetPosition.HOUSE */.Tu.HOUSE) {
        return Result.HOUSE;
    }
    var roundResultPosition = round.closePrice > round.lockPrice ? types/* BetPosition.BULL */.Tu.BULL : types/* BetPosition.BEAR */.Tu.BEAR;
    return bet.position === roundResultPosition ? Result.WIN : Result.LOSE;
};
var getFilteredBets = function(bets, filter) {
    switch(filter){
        case types/* HistoryFilter.COLLECTED */.dZ.COLLECTED:
            return bets.filter(function(bet) {
                return bet.claimed === true;
            });
        case types/* HistoryFilter.UNCOLLECTED */.dZ.UNCOLLECTED:
            return bets.filter(function(bet) {
                return !bet.claimed && (bet.position === bet.round.position || bet.round.failed === true);
            });
        case types/* HistoryFilter.ALL */.dZ.ALL:
        default:
            return bets;
    }
};
var getTotalWonMarket = function(market, tokenSymbol) {
    var total = market["total".concat(tokenSymbol)] ? parseFloat(market["total".concat(tokenSymbol)]) : 0;
    var totalTreasury = market["total".concat(tokenSymbol, "Treasury")] ? parseFloat(market["total".concat(tokenSymbol, "Treasury")]) : 0;
    return Math.max(total - totalTreasury, 0);
};
var getTotalWon = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var _ref, _ref_, BNBMarket, CAKEMarket, totalWonBNB, totalWonCAKE;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            (0,dist.request)(endpoints/* GRAPH_API_PREDICTION_BNB */.GZ, (0,dist.gql)(_templateObject())),
                            (0,dist.request)(endpoints/* GRAPH_API_PREDICTION_CAKE */.fO, (0,dist.gql)(_templateObject1()))
                        ])
                    ];
                case 1:
                    _ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        1
                    ]), _ref_ = _ref[0], BNBMarket = _ref_.market, CAKEMarket = _ref_.market;
                    totalWonBNB = getTotalWonMarket(BNBMarket, "BNB");
                    totalWonCAKE = getTotalWonMarket(CAKEMarket, "CAKE");
                    return [
                        2,
                        {
                            totalWonBNB: totalWonBNB,
                            totalWonCAKE: totalWonCAKE
                        }
                    ];
            }
        });
    });
    return function getTotalWon() {
        return _ref.apply(this, arguments);
    };
}();
var getBetHistory = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var where, first, skip, api, tokenSymbol, response;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    where = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, first = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1000, skip = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 0, api = _arguments.length > 3 ? _arguments[3] : void 0, tokenSymbol = _arguments.length > 4 ? _arguments[4] : void 0;
                    return [
                        4,
                        (0,dist.request)(api, (0,dist.gql)(_templateObject2(), getBetBaseFields(tokenSymbol), getRoundBaseFields(tokenSymbol), getUserBaseFields(tokenSymbol)), {
                            first: first,
                            skip: skip,
                            where: where
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.bets
                    ];
            }
        });
    });
    return function getBetHistory() {
        return _ref.apply(this, arguments);
    };
}();
var getLedgerData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account, epochs, address) {
        var ledgerCalls, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ledgerCalls = epochs.map(function(epoch) {
                        return {
                            address: address,
                            name: "ledger",
                            params: [
                                epoch,
                                account
                            ]
                        };
                    });
                    return [
                        4,
                        (0,multicall/* multicallv2 */.vf)({
                            abi: predictions,
                            calls: ledgerCalls
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function getLedgerData(account, epochs, address) {
        return _ref.apply(this, arguments);
    };
}();
var LEADERBOARD_RESULTS_PER_PAGE = 20;
var defaultPredictionUserOptions = {
    skip: 0,
    first: LEADERBOARD_RESULTS_PER_PAGE,
    orderBy: "createdAt",
    orderDir: "desc"
};
var getHasRoundFailed = function(oracleCalled, closeTimestamp, buffer) {
    if (!oracleCalled) {
        var closeTimestampMs = (closeTimestamp + buffer) * 1000;
        if (Number.isFinite(closeTimestampMs)) {
            return Date.now() > closeTimestampMs;
        }
    }
    return false;
};
var getPredictionUsers = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var options, api, tokenSymbol, _object_spread1, first, skip, where, orderBy, orderDir, response;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, api = _arguments.length > 1 ? _arguments[1] : void 0, tokenSymbol = _arguments.length > 2 ? _arguments[2] : void 0;
                    _object_spread1 = (0,_object_spread/* default */.Z)({}, defaultPredictionUserOptions, options), first = _object_spread1.first, skip = _object_spread1.skip, where = _object_spread1.where, orderBy = _object_spread1.orderBy, orderDir = _object_spread1.orderDir;
                    return [
                        4,
                        (0,dist.request)(api, (0,dist.gql)(_templateObject3(), getUserBaseFields(tokenSymbol)), {
                            first: first,
                            skip: skip,
                            where: where,
                            orderBy: orderBy,
                            orderDir: orderDir
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.users
                    ];
            }
        });
    });
    return function getPredictionUsers() {
        return _ref.apply(this, arguments);
    };
}();
var getPredictionUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account, api, tokenSymbol) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,dist.request)(api, (0,dist.gql)(_templateObject4(), getUserBaseFields(tokenSymbol)), {
                            id: account.toLowerCase()
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.user
                    ];
            }
        });
    });
    return function getPredictionUser(account, api, tokenSymbol) {
        return _ref.apply(this, arguments);
    };
}();
var getClaimStatuses = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account, epochs, address) {
        var claimableCalls, claimableResponses;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    claimableCalls = epochs.map(function(epoch) {
                        return {
                            address: address,
                            name: "claimable",
                            params: [
                                epoch,
                                account
                            ]
                        };
                    });
                    return [
                        4,
                        (0,multicall/* multicallv2 */.vf)({
                            abi: predictions,
                            calls: claimableCalls
                        })
                    ];
                case 1:
                    claimableResponses = _state.sent();
                    return [
                        2,
                        claimableResponses.reduce(function(accum, claimableResponse, index) {
                            var epoch = epochs[index];
                            var _claimableResponse = (0,_sliced_to_array/* default */.Z)(claimableResponse, 1), claimable = _claimableResponse[0];
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, epoch, claimable));
                        }, {})
                    ];
            }
        });
    });
    return function getClaimStatuses(account, epochs, address) {
        return _ref.apply(this, arguments);
    };
}();
var getPredictionData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(address) {
        var staticCalls, _ref, _ref_, currentEpoch, _ref_1, intervalSeconds, _ref_2, minBetAmount, _ref_3, paused;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    staticCalls = [
                        "currentEpoch",
                        "intervalSeconds",
                        "minBetAmount",
                        "paused"
                    ].map(function(method) {
                        return {
                            address: address,
                            name: method
                        };
                    });
                    return [
                        4,
                        (0,multicall/* multicallv2 */.vf)({
                            abi: predictions,
                            calls: staticCalls
                        })
                    ];
                case 1:
                    _ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        4
                    ]), _ref_ = (0,_sliced_to_array/* default */.Z)(_ref[0], 1), currentEpoch = _ref_[0], _ref_1 = (0,_sliced_to_array/* default */.Z)(_ref[1], 1), intervalSeconds = _ref_1[0], _ref_2 = (0,_sliced_to_array/* default */.Z)(_ref[2], 1), minBetAmount = _ref_2[0], _ref_3 = (0,_sliced_to_array/* default */.Z)(_ref[3], 1), paused = _ref_3[0];
                    return [
                        2,
                        {
                            status: paused ? types/* PredictionStatus.PAUSED */.Gw.PAUSED : types/* PredictionStatus.LIVE */.Gw.LIVE,
                            currentEpoch: currentEpoch.toNumber(),
                            intervalSeconds: intervalSeconds.toNumber(),
                            minBetAmount: minBetAmount.toString()
                        }
                    ];
            }
        });
    });
    return function getPredictionData(address) {
        return _ref.apply(this, arguments);
    };
}();
var getRoundsData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(epochs, address) {
        var calls, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    calls = epochs.map(function(epoch) {
                        return {
                            address: address,
                            name: "rounds",
                            params: [
                                epoch
                            ]
                        };
                    });
                    return [
                        4,
                        (0,multicall/* multicallv2 */.vf)({
                            abi: predictions,
                            calls: calls
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function getRoundsData(epochs, address) {
        return _ref.apply(this, arguments);
    };
}();
var makeFutureRoundResponse = function(epoch, startTimestamp) {
    return {
        epoch: epoch,
        startTimestamp: startTimestamp,
        lockTimestamp: null,
        closeTimestamp: null,
        lockPrice: null,
        closePrice: null,
        totalAmount: bignumbers/* Zero.toJSON */._Y.toJSON(),
        bullAmount: bignumbers/* Zero.toJSON */._Y.toJSON(),
        bearAmount: bignumbers/* Zero.toJSON */._Y.toJSON(),
        rewardBaseCalAmount: bignumbers/* Zero.toJSON */._Y.toJSON(),
        rewardAmount: bignumbers/* Zero.toJSON */._Y.toJSON(),
        oracleCalled: false,
        lockOracleId: null,
        closeOracleId: null
    };
};
var makeRoundData = function(rounds) {
    return rounds.reduce(function(accum, round) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, round.epoch.toString(), round));
    }, {});
};
var serializePredictionsLedgerResponse = function(ledgerResponse) {
    return {
        position: ledgerResponse.position === 0 ? types/* BetPosition.BULL */.Tu.BULL : types/* BetPosition.BEAR */.Tu.BEAR,
        amount: ledgerResponse.amount.toJSON(),
        claimed: ledgerResponse.claimed
    };
};
var makeLedgerData = function(account, ledgers, epochs) {
    return ledgers.reduce(function(accum, ledgerResponse, index) {
        if (!ledgerResponse) {
            return accum;
        }
        // If the amount is zero that means the user did not bet
        if (ledgerResponse.amount.eq(0)) {
            return accum;
        }
        var epoch = epochs[index].toString();
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, account, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum[account]), (0,_define_property/* default */.Z)({}, epoch, serializePredictionsLedgerResponse(ledgerResponse)))));
    }, {});
};
/**
 * Serializes the return from the "rounds" call for redux
 */ var serializePredictionsRoundsResponse = function(response) {
    var epoch = response.epoch, startTimestamp = response.startTimestamp, lockTimestamp = response.lockTimestamp, closeTimestamp = response.closeTimestamp, lockPrice = response.lockPrice, closePrice = response.closePrice, totalAmount = response.totalAmount, bullAmount = response.bullAmount, bearAmount = response.bearAmount, rewardBaseCalAmount = response.rewardBaseCalAmount, rewardAmount = response.rewardAmount, oracleCalled = response.oracleCalled, lockOracleId = response.lockOracleId, closeOracleId = response.closeOracleId;
    return {
        oracleCalled: oracleCalled,
        epoch: epoch.toNumber(),
        startTimestamp: startTimestamp.eq(0) ? null : startTimestamp.toNumber(),
        lockTimestamp: lockTimestamp.eq(0) ? null : lockTimestamp.toNumber(),
        closeTimestamp: closeTimestamp.eq(0) ? null : closeTimestamp.toNumber(),
        lockPrice: lockPrice.eq(0) ? null : lockPrice.toJSON(),
        closePrice: closePrice.eq(0) ? null : closePrice.toJSON(),
        totalAmount: totalAmount.toJSON(),
        bullAmount: bullAmount.toJSON(),
        bearAmount: bearAmount.toJSON(),
        rewardBaseCalAmount: rewardBaseCalAmount.toJSON(),
        rewardAmount: rewardAmount.toJSON(),
        lockOracleId: lockOracleId.toString(),
        closeOracleId: closeOracleId.toString()
    };
};
/**
 * Parse serialized values back into BigNumber
 * BigNumber values are stored with the "toJSON()" method, e.g  { type: "BigNumber", hex: string }
 */ var parseBigNumberObj = function(data) {
    return Object.keys(data).reduce(function(accum, key) {
        var value = data[key];
        if (value && (value === null || value === void 0 ? void 0 : value.type) === "BigNumber") {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, key, bignumber/* BigNumber.from */.O$.from(value)));
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, key, value));
    }, {});
};
var fetchUsersRoundsLength = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account, address) {
        var contract, length, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    contract = (0,contractHelpers/* getPredictionsContract */.qi)(address);
                    return [
                        4,
                        contract.getUserRoundsLength(account)
                    ];
                case 1:
                    length = _state.sent();
                    return [
                        2,
                        length
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        bignumbers/* Zero */._Y
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchUsersRoundsLength(account, address) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetches rounds a user has participated in
 */ var fetchUserRounds = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account) {
        var cursor, size, address, contract, _ref, rounds, ledgers, e;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    cursor = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 0, size = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : config/* ROUNDS_PER_PAGE */.yg, address = _arguments.length > 3 ? _arguments[3] : void 0;
                    contract = (0,contractHelpers/* getPredictionsContract */.qi)(address);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        contract.getUserRounds(account, cursor, size)
                    ];
                case 2:
                    _ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), rounds = _ref[0], ledgers = _ref[1];
                    return [
                        2,
                        rounds.reduce(function(accum, round, index) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accum), (0,_define_property/* default */.Z)({}, round.toString(), serializePredictionsLedgerResponse(ledgers[index])));
                        }, {})
                    ];
                case 3:
                    e = _state.sent();
                    // When the results run out the contract throws an error.
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchUserRounds(account) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);